/**
 * cart-upsell.js
 * ---------------------------------------------------------------------------
 * Cart drawer upsell, Buck Mason "Pair it with" style, STACKED (no carousel).
 *
 * - Looks at the FIRST item currently in the cart
 * - Fetches Shopify complementary recommendations for that product
 *   (Product Recommendations API, intent=complementary)
 * - Renders stacked rows into #upsell-main [data-upsell-slides]
 * - "Add" adds instantly via /cart/add.js, then lets the theme's CartSection
 *   re-render + open the drawer (via the product:added event it already listens for)
 * - Refreshes whenever the drawer opens or an item is added
 *
 * NOTE: complementary products must be configured in
 * Search & Discovery -> Recommendations, or the API returns none and the
 * block stays hidden.
 * ---------------------------------------------------------------------------
 */
(function () {
  var UPSELL_SELECTOR = '[data-cart-upsell]';

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function imageUrl(src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=500';
  }

  // Stacked row: image | title + price | Add
  function buildRow(p) {
    var variant = p.variants && p.variants[0];
    var variantId = variant ? variant.id : '';
    var available = variant ? variant.available !== false : p.available !== false;
    var img = p.featured_image
      ? '<img src="' + imageUrl(p.featured_image) + '" alt="' + escapeHtml(p.title) + '">'
      : '';
    var btn = available
      ? '<button class="btn-upsell" type="button" data-upsell-add data-variant-id="' + variantId + '">Add</button>'
      : '<button class="btn-upsell" type="button" disabled>Sold out</button>';

    return ''
      + '<div class="upsell__item slider-card">'
      +   '<div class="img__container"><a href="' + p.url + '">' + img + '</a></div>'
      +   '<div class="text__container">'
      +     '<h3 class="title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></h3>'
      +     '<div class="upsell__meta">'
      +       '<p class="price">' + money(p.price) + '</p>'
      // +       btn
      +     '</div>'
      +   '</div>'
      + '</div>';
  }

  function renderCartUpsell() {
    var root = document.querySelector(UPSELL_SELECTOR);
    if (!root) return;
    var listWrap = root.querySelector('[data-upsell-slides]');
    if (!listWrap) return;

    var intent = root.getAttribute('data-intent') || 'complementary';
    var limit = root.getAttribute('data-limit') || 4;
    var base = rootUrl();

    // 1) Current cart -> first item's product id
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) {
          root.style.display = 'none';
          return;
        }
        var productId = cart.items[0].product_id;

        var url = base + 'recommendations/products.json?product_id=' + productId
                + '&intent=' + intent + '&limit=' + limit;
        return fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data && data.products) || [];
            if (!products.length) {
              root.style.display = 'none';
              return;
            }
            listWrap.innerHTML = products.map(buildRow).join('');
            root.style.display = '';
          });
      })
      .catch(function () { root.style.display = 'none'; });
  }

  // Ajax add-to-cart for upsell "Add" buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn || btn.hasAttribute('disabled')) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var original = btn.textContent;
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Adding...';
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        btn.removeAttribute('disabled');
        btn.textContent = original;
        if (!res.ok) return;
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: { id: Number(variantId) }, quantity: 1 }
        }));
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        btn.removeAttribute('disabled');
        btn.textContent = original;
      });
  });

  // Populate on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderCartUpsell);
  } else {
    renderCartUpsell();
  }

  // Refresh after an item is added
  document.addEventListener('product:added', function () {
    setTimeout(renderCartUpsell, 400);
  });

  // Refresh every time the cart drawer opens (covers item removal, etc.)
  var drawer = document.getElementById('sidebar-cart');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        renderCartUpsell();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
})();